import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/img/elite-logo.png"; // Use the correct path for the logo

const Invoice = () => {
  const location = useLocation();
  const booking = location.state?.booking;

  const gstRate = 0.12; // 12% GST rate
  const amount = parseFloat(booking?.amount.replace("₹", "") || 0);
  const gst = (amount * gstRate) / (1 + gstRate); // Extract GST included in Room Tariff
  const tariffWithoutGst = amount - gst;

  const navigate = useNavigate(); // For navigation to adminhome

  useEffect(() => {
    // Automatically open the invoice in a new window for printing
    const newWindow = window.open("", "_blank", "width=800,height=600");
    if (newWindow) {
      const styles = `
        body { font-family: Arial, sans-serif; line-height: 1.6; }
        .invoice-container { max-width: 600px; margin: auto; padding: 20px; border: 1px solid #ccc; border-radius: 8px; }
        .header { text-align: center; margin-bottom: 20px; }
        .header img { max-height: 60px; }
        .header h1 { font-size: 24px; margin: 5px 0; }
        .header p { font-size: 14px; color: #555; }
        .details, .totals, .footer { margin-bottom: 20px; }
        .details .row, .totals .row { display: flex; justify-content: space-between; margin-bottom: 5px; }
        .totals { font-size: 16px; }
        .footer { text-align: center; font-size: 12px; color: #666; }
        .footer p { margin: 5px 0; }
        .total-amount { font-size: 18px; font-weight: bold; text-align: right; }
      `;

      newWindow.document.write(`
        <html>
          <head>
            <title>Invoice - ${booking.bookingId}</title>
            <style>${styles}</style>
          </head>
          <body>
            <div class="invoice-container">
              <div class="header">
                <img src="${window.location.origin + logo}" alt="Signature Hotels Logo" />
                <h1>SIGNATURE HOTELS & RESORTS</h1>
                <p>Hotel Elite by Signature Group</p>
                <p>Address: 11-28/21, Airport Road, Shamshabad, Hyderabad - 501218</p>
                <p>Phone: 8121001084</p>
              </div>

              <div class="details">
                <div class="row">
                  <div>Invoice No:</div>
                  <div>${booking.bookingId || "N/A"}</div>
                </div>
                <div class="row">
                  <div>Invoice Date:</div>
                  <div>${new Date().toLocaleDateString()}</div>
                </div>
                <div class="row">
                  <div>Booking Date:</div>
                  <div>${new Date(booking.checkInDate).toLocaleDateString() || "N/A"}</div>
                </div>
                <div class="row">
                  <div>Guest Name:</div>
                  <div>${booking.customerName || "N/A"}</div>
                </div>
                <div class="row">
                  <div>Contact:</div>
                  <div>${booking.phoneNumber || "N/A"}</div>
                </div>
                <div class="row">
                  <div>Address:</div>
                  <div>${booking.address || "N/A"}</div>
                </div>
                <div class="row">
                  <div>Check-In:</div>
                  <div>${new Date(booking.checkInDate).toLocaleDateString() || "N/A"}</div>
                </div>
                <div class="row">
                  <div>Check-Out:</div>
                  <div>${new Date(booking.checkOutDate).toLocaleDateString() || "N/A"}</div>
                </div>
                <div class="row">
                  <div>Room Type:</div>
                  <div>${booking.roomType || "N/A"}</div>
                </div>
                <div class="row">
                  <div>Meal Plan:</div>
                  <div>${booking.mealPlan || "N/A"}</div>
                </div>
              </div>

              <div class="totals">
                <div class="row">
                  <div>Room Tariff (Including GST):</div>
                  <div>₹${amount.toFixed(2)}</div>
                </div>
                <div class="row">
                  <div>Goods and Services Tax (12%):</div>
                  <div>₹${gst.toFixed(2)}</div>
                </div>
                <div class="row">
                  <div>Tariff Without GST:</div>
                  <div>₹${tariffWithoutGst.toFixed(2)}</div>
                </div>
                <div class="total-amount">
                  Total: ₹${amount.toFixed(2)}
                </div>
              </div>

              <div class="footer">
                <p>All payments are to be made by CASH/CARD/NEFT/UPI in the name of "SIGNATURE GROUP OF HOTELS"</p>
                <p>If you have any queries regarding this invoice, please contact us.</p>
                <p>We Will Do Our Best, Thank You For Your Business</p>
              </div>
            </div>
          </body>
        </html>
      `);

      newWindow.document.close();
      newWindow.print(); // Automatically trigger the print dialog
      newWindow.onafterprint = () => navigate("/adminhome"); // Navigate after printing
    }
  }, [booking, navigate, amount, gst]);

  return null; // Nothing is rendered in the current tab
};

export default Invoice;

